import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { GlobalVariable } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("GLOBAL_VARIABLES_MODULE");

export const moduleActions = createDataModuleActions<GlobalVariable>(actionCreator);
export const getGlobalVariablesTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const globalVariablesActions = {
  ...normalizeActions(moduleActions.data),
};
export const globalVariablesActionCreators = {
  ...moduleActions,
};
